<template>
  <section class="section">
    <div class="container">
      <div class="contact-wrap dark-card reveal">
        <div class="contact-wrap__glow" aria-hidden="true"></div>

        <div class="contact-grid">
          <div class="contact-info">
            <span class="eyebrow">Get In Touch</span>
            <h2 class="heading-lg">Elevate your brand with Me</h2>
            <p class="body-sm">
              Ready to start your next project? Fill out the form and I'll get back
              to you within 24 hours.
            </p>

            <div class="contact-details">
              <a :href="`mailto:${SITE.email}`" class="contact-detail">
                <v-icon size="18">mdi-email-outline</v-icon>
                {{ SITE.email }}
              </a>
              <span class="contact-detail">
                <v-icon size="18">mdi-map-marker-outline</v-icon>
                {{ SITE.location }}
              </span>
              <a :href="`tel:${SITE.phone}`" class="contact-detail">
                <v-icon size="18">mdi-phone-outline</v-icon>
                {{ SITE.phone }}
              </a>
            </div>
          </div>

          <form class="contact-form" @submit.prevent="handleSubmit">
            <div class="contact-form__row">
              <input v-model="form.name" type="text" placeholder="Your Name" required class="contact-input" />
              <input v-model="form.phone" type="tel" placeholder="Phone Number" class="contact-input" />
            </div>
            <div class="contact-form__row">
              <input v-model="form.email" type="email" placeholder="Your Email" required class="contact-input" />
              <input v-model="form.subject" type="text" placeholder="Subject" class="contact-input" />
            </div>
            <textarea
              v-model="form.message"
              placeholder="Your Message"
              rows="5"
              required
              class="contact-input contact-input--area"
            ></textarea>
            <button type="submit" class="btn btn--accent contact-form__submit">
              Appointment Now
              <v-icon size="18">mdi-arrow-right</v-icon>
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive } from "vue";
import { SITE } from "@/constants/site";
import { useScrollReveal } from "@/composables/useScrollReveal";

useScrollReveal();

const form = reactive({
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
});

const handleSubmit = () => {
  const body = encodeURIComponent(
    `Name: ${form.name}\nPhone: ${form.phone}\n\n${form.message}`
  );
  window.location.href = `mailto:${SITE.email}?subject=${encodeURIComponent(form.subject || "Portfolio Inquiry")}&body=${body}`;
};
</script>

<style scoped>
.contact-wrap {
  padding: clamp(2rem, 5vw, 3.5rem);
  position: relative;
  overflow: hidden;
  border-top: 2px solid var(--color-accent);
  border-left: 2px solid var(--color-accent);
}

.contact-wrap__glow {
  position: absolute;
  bottom: -30%;
  right: -10%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, var(--color-accent-glow), transparent 70%);
  pointer-events: none;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  position: relative;
  z-index: 1;
}

@media (min-width: 960px) {
  .contact-grid {
    grid-template-columns: 1fr 1.2fr;
    gap: 4rem;
    align-items: start;
  }
}

.contact-info .heading-lg {
  margin-bottom: 1rem;
}

.contact-info .body-sm {
  margin-bottom: 2rem;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.contact-detail {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  color: var(--color-text-muted);
  transition: color var(--transition);
}

a.contact-detail:hover {
  color: var(--color-accent);
}

.contact-form__row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

@media (min-width: 600px) {
  .contact-form__row {
    grid-template-columns: 1fr 1fr;
  }
}

.contact-input {
  width: 100%;
  padding: 1rem 1.25rem;
  font-family: var(--font-sans);
  font-size: 0.875rem;
  color: var(--color-text);
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  outline: none;
  transition: border-color var(--transition);
}

.contact-input::placeholder {
  color: var(--color-text-faint);
}

.contact-input:focus {
  border-color: var(--color-accent);
}

.contact-input--area {
  resize: vertical;
  min-height: 120px;
  margin-bottom: 1.25rem;
}

.contact-form__submit {
  width: 100%;
}
</style>
